import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    },
    {
      path: '/',
      name: 'index',
      component: () => import('./views/Index.vue')
    },
    {
      path: '/sign-in',
      name: 'sign-in',
      component: () => import('./views/SignIn.vue')
    }, {
      path: '/sign-up',
      name: 'sign-up',
      component: () => import('./views/SignUp.vue')
    }, {
      path: '/user-info',
      name: 'user-info',
      component: () => import('./views/UserInfo.vue')
    }, {
      path: '/select-region',
      name: 'select-region',
      component: () => import('./views/SelectRegion.vue')
    }, {
      path: '/used-device',
      name: 'used-device',
      component: () => import('./views/UsedDevice.vue')
    }, {
      path: '/contact-us',
      name: 'contact-us',
      component: () => import('./views/ContactUs.vue')
    }, {
      path: '/reset-password',
      name: 'reset-password',
      component: () => import('./views/ResetPassword.vue')
    }, {
      path: '/retrieve-username',
      name: 'retrieve-username',
      component: () => import('./views/RetrieveUsername.vue')
    }, {
      path: '/mobile-reset',
      name: 'mobile-reset',
      component: () => import('./views/MobileReset.vue')
    }, {
      path: '/email-reset',
      name: 'email-reset',
      component: () => import('./views/EmailReset.vue')
    }, {
      path: '/question-reset',
      name: 'question-reset',
      component: () => import('./views/QuestionReset.vue')
    }, {
      path: '/none-reset',
      name: 'none-reset',
      component: () => import('./views/NoneReset.vue')
    }, {
      path: '/email-retrieve',
      name: 'email-retrieve',
      component: () => import('./views/EmailRetrieve.vue')
    }, {
      path: '/none-retrieve',
      name: 'none-retrieve',
      component: () => import('./views/NoneRetrieve.vue')
    }, {
      path: '/privacy-terms',
      name: 'privacy-terms',
      component: () => import('./views/PrivacyTerms.vue')
    }, {
      path: '/personal-information',
      name: 'personal-information',
      component: () => import('./views/PersonalInformation.vue')
    }, {
      path: '/device-service',
      name: 'device-service',
      component: () => import('./views/DeviceService.vue')
    }, {
      path: '/notification',
      name: 'notification',
      component: () => import('./views/Notification.vue')
    }, {
      path: '/management',
      name: 'management',
      component: () => import('./views/Management.vue')
    }, {
      path: '/disclaimer',
      name: 'disclaimer',
      component: () => import('./views/Disclaimer.vue')
    }, {
      path: '/select-user-type',
      name: 'select-user-type',
      component: () => import('./views/SelectUserType.vue')
    }, {
      path: '/bound-account',
      name: 'bound-account',
      component: () => import('./views/BoundAccount.vue')
    }, {
      path: '/bound-mobile',
      name: 'bound-mobile',
      component: () => import('./views/BoundMobile.vue')
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    // 判断from页面是否有滚动行为
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})
